import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background-color: white;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px 0;
  font-family: 'Mozilla Text', serif;
  font-size: clamp(0.9rem, 2vw, 1.1rem);
  font-weight: bold;
  color: #8a8affff;
`;

const Copyright = styled.p`
  font-family: 'Mozilla Text', serif;
  font-size: clamp(0.9rem, 2vw, 1.1rem);
  font-weight: bold;
  color: #8a8affff;
`;

const PrivacyLink = styled.a`
  text-decoration: none;
  color: #8a8affff;

  &:hover {
    color: rgba(105, 146, 252, 1);
  }
`;

export default function Footer() {
  return (
    <FooterContainer>

      <FooterContent>

        <Copyright>

          © 2026 Anna Miki •{" "}
          <PrivacyLink href="/privacy-policy">Privacy Policy</PrivacyLink>

        </Copyright>

      </FooterContent>

    </FooterContainer>
  );
}
